/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Hidden16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M15.278.354a.5.5 0 010 .707L1.136 15.203a.5.5 0 01-.707-.707l2.438-2.439A8.925 8.925 0 01.071 8.186L0 7.998l.07-.188c1.272-3.394 4.396-5.678 7.931-5.678a8.16 8.16 0 013.835.957L14.571.354a.5.5 0 01.707 0zM13.47 4.219a8.948 8.948 0 012.461 3.592l.07.187-.07.188c-1.27 3.395-4.394 5.68-7.929 5.68a8.149 8.149 0 01-3.424-.754l.812-.812c.819.324 1.7.499 2.612.499 3.018 0 5.702-1.917 6.862-4.8a7.862 7.862 0 00-2.148-3.024l.754-.756zM8.001 3.2C4.983 3.2 2.299 5.116 1.137 8a7.839 7.839 0 002.489 3.3L5.66 9.264A2.657 2.657 0 015.344 8a2.66 2.66 0 012.657-2.668c.447 0 .882.113 1.267.323l1.773-1.772a7.097 7.097 0 00-3.04-.684zm2.523 3.966c.087.267.132.547.131.833a2.658 2.658 0 01-3.494 2.53l.942-.94A1.592 1.592 0 009.59 8.102l.934-.937zm-2.523-.767a1.594 1.594 0 00-1.528 2.053l1.986-1.986A1.59 1.59 0 008 6.398z"
        />
    </AccessibleSVG>
);

export default Hidden16;
